import { PreviewControls } from '@hendrx/core/common/components/preview/PreviewControls';
import { stageContainerHeightVar } from '@hendrx/core/common/contentObjects';
import { PlenaryPageWrapper } from '@hendrx/core/plenary/components/PlenaryPageWrapper';
import { PlenaryPlayerTopBar } from '@hendrx/core/plenary/components/PlenaryPlayerTopBar';
import { PlenaryPreviewProviders } from '@hendrx/core/plenary/components/PlenaryPreviewProviders';
import { useGetPlenaryDraftByIdQuery } from '@hendrx/core/plenary/queries/getPlenaryDraftById';
import { AppShell, Center, Container, rem } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { HEADER_HEIGHT_PX } from 'shared/client/consts/styleConsts';
import { useLearningObjectCommonData } from 'shared/components/providers/LearningObjectCommonDataProvider';
import { useCustomUIConfigurations } from 'shared/utils/useCustomUIConfigurations';
import { useFullscreen } from 'shared/utils/useFullscreen';
import { useUiLanguage } from 'shared/utils/useUiLanguage';

export const Route = createFileRoute('/studio/plenary/preview/$plenaryDraftId')({
  component: RouteComponent
});

function RouteComponent() {
  const { plenaryDraftId } = Route.useParams();
  return (
    <PlenaryPreviewProviders plenaryDraftId={plenaryDraftId}>
      <PreviewPage />
    </PlenaryPreviewProviders>
  );
}

function PreviewPage() {
  const { t } = useTranslation('components');
  const { learningObjectDraftId: plenaryDraftId } = useLearningObjectCommonData();
  const { isLoading, error } = useGetPlenaryDraftByIdQuery(plenaryDraftId);

  const { height } = useViewportSize();

  const { toggle: onFullscreenToggle, isFullscreen } = useFullscreen();
  const { uiDirection } = useUiLanguage();

  const { disableDevicePicker, disableTopbar } = useCustomUIConfigurations();

  const headerHeight = isFullscreen || disableTopbar ? 0 : HEADER_HEIGHT_PX;

  if (error) {
    return (
      <Container h={height} size="100%">
        <Center h="100%">{t('studio.learningObjectDraftFetchError')}</Center>
      </Container>
    );
  }

  return (
    <AppShell dir={uiDirection} padding="0" withBorder={false}>
      {!isFullscreen && !disableTopbar && (
        <AppShell.Header>
          <PlenaryPlayerTopBar onFullscreenToggle={onFullscreenToggle} />
        </AppShell.Header>
      )}
      <AppShell.Main mih="0">
        <Container
          style={{
            height: `calc(${height}px - ${rem(headerHeight)})`,
            [stageContainerHeightVar]: `calc(${height}px - ${rem(headerHeight)})`,
            marginTop: rem(headerHeight),
            padding: '0',
            position: 'relative'
          }}
          size="100%"
        >
          {!isLoading && (
            <>
              <PlenaryPageWrapper />
              {!isFullscreen && !disableDevicePicker && <PreviewControls withDeviceSelector={false} position="left" />}
            </>
          )}
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}
